var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ReactComponent as AmenitiesIcon } from '../../assets/icons/nebula/amenities.svg';
import { ReactComponent as KidsIcon } from '../../assets/icons/nebula/child.svg';
import { ReactComponent as GroupsIcon } from '../../assets/icons/nebula/groups.svg';
import { ReactComponent as GuestsIcon } from '../../assets/icons/nebula/guests.svg';
import { ReactComponent as BedsIcon } from '../../assets/icons/nebula/beds.svg';
import { ReactComponent as BedIcon } from '../../assets/icons/nebula/bed.svg';
import { ReactComponent as CalendarIcon } from '../../assets/icons/nebula/calendar.svg';
import { ReactComponent as PhoneIcon } from '../../assets/icons/nebula/phone.svg';
import { ReactComponent as EmailIcon } from '../../assets/icons/nebula/email.svg';
import { ReactComponent as PropertyIcon } from '../../assets/icons/nebula/property.svg';
import { ReactComponent as SlidersIcon } from '../../assets/icons/nebula/sliders.svg';
import { ReactComponent as TagIcon } from '../../assets/icons/nebula/tag.svg';
import { ReactComponent as UserIcon } from '../../assets/icons/nebula/user.svg';
const getSize = (size) => {
    switch (size) {
        case 'xs':
            return 16;
        case 'sm':
            return 20;
        case 'md':
            return 24;
        case 'lg':
            return 32;
        case 'xl':
            return 40;
        default:
            return 24;
    }
};
export const NebulaIconWrapper = (_a) => {
    var { name, color, size = 'md', style } = _a, rest = __rest(_a, ["name", "color", "size", "style"]);
    const iconStyle = Object.assign({ alignItems: 'center', color, display: 'inline-flex', height: getSize(size), justifyContent: 'center', width: getSize(size) }, style);
    let IconComponent;
    switch (name) {
        case 'adults':
            IconComponent = GuestsIcon;
            break;
        case 'amenities':
            IconComponent = AmenitiesIcon;
            break;
        case 'bed':
            IconComponent = BedIcon;
            break;
        case 'beds':
            IconComponent = BedsIcon;
            break;
        case 'calendar':
            IconComponent = CalendarIcon;
            break;
        case 'email':
            IconComponent = EmailIcon;
            break;
        case 'guests':
            IconComponent = GroupsIcon;
            break;
        case 'kids':
            IconComponent = KidsIcon;
            break;
        case 'phone':
            IconComponent = PhoneIcon;
            break;
        case 'property':
            IconComponent = PropertyIcon;
            break;
        case 'sliders':
            IconComponent = SlidersIcon;
            break;
        case 'tag':
            IconComponent = TagIcon;
            break;
        case 'user':
            IconComponent = UserIcon;
            break;
        default:
            return null;
    }
    return (_jsx("span", Object.assign({}, rest, { "data-testid": rest['data-testid'], style: iconStyle, children: _jsx(IconComponent, { style: { color: 'inherit', height: '100%', width: '100%' } }) })));
};
